<template>
<div class="popup" v-cloak v-if="bindEmailShow" style="zIndex:200">
    <div class="content" id="bindPass">
        <div class="title" style="border-radius: 9px 9px 0 0;">
            {{$t('language.popup.personalCenter.bindEmail')}}
            <div class="icon white-close dialog-close" @click="closePage()"></div>
        </div>
        <div class="personInfo-content" style="flex-direction: column;">
            <div class="before-subscribe" v-if="touristPurchase">
                 <span class="icon-notice"></span>
                 <span>{{$t('language.paySystem.beforeBind')}}</span>
            </div>
            <div style="display: inline-flex;">
                <div class="personInfo-column">
                    <span> {{$t('language.common.emailAccount')}}</span>
                    <span>{{$t('language.common.newPassword')}}</span>
                </div>
                <div class="personInfo-column personInfo-column-msg">
                    <input v-model="email" @blur="testEmail()" />
                    <div class="password-input">
                        <input type="password" ref="passWord" @blur="passwordVerification()" v-model="passWord" maxlength="16"/>
                        <div class="password-eye" :class="showPassword?'icon-eye':'icon-eye-hide'" @click="checkShowPassword()"></div>
                    </div>
                </div>

                <button class="personInfo-button" v-if="!touristPurchase" @click="updateUserInfo()" :class="passWord&&email?'':'button-noclick'">{{$t('language.common.save')}}</button>
                <button class="personInfo-button" v-else  @click="updateUserInfo()" :class="passWord&&email?'':'button-noclick'">{{$t('language.popup.reportPopup.next')}}</button>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import commonstate from '@/js/constant.js';
import googleAnalyticsUtil from "../../../js/workspace/google_analytics_util.js";
import commonUtils from "@/js/workspace/common_util.js";
export default {
    data: function () {
        return {
            bindEmailShow: false,
            email: '',
            userName: '',
            passWord: '',
            repeatPassWord: '',
            bindEmailFlag:false,//用于标识是否绑定邮箱
            touristPurchase:false,//是否是游客进行购买
            paySource:null,//标明购买来源
            item:null,//用户需要购买的项目
            showPassword: false,
        }
    },
    created() {
        let user = commonUtils.getUser();
        if(user){
            this.userName = user.username;
        }
    },
    methods: {
        closePage() {
            this.bindEmailShow = false;
            this.email = null;
            this.passWord = null;
            this.repeatPassWord = null;
            this.showPassword = false;
            this.$refs.passWord.type = "password";
        },
        testEmail() {
            if (this.email) {
                if (this.email.indexOf('@')==-1 || !commonstate.emailpattern.test(this.email)) {
                    this.$toast({
                        text: this.$t('language.login.validEmail'),
                        type: 'fail',
                        idValue: "bindPass"
                    });
                    return false;
                };
            }
        },
        passwordVerification() {
            if (this.passWord) {
                if (this.passWord.length > 16 || this.passWord.length < 8) {
                    this.$toast({
                        text: this.$t('language.login.passwordCharacters'),
                        type: 'fail',
                        idValue: "bindPass"
                    });
                    return false;
                }
            }
        },
        verificationRepeatPassword() {
            if (this.passWord && this.repeatPassWord && this.passWord != this.repeatPassWord) {
                this.$toast({
                    text: this.$t('language.login.passwordnotMatch'),
                    type: 'fail',
                    idValue: "bindPass"
                });
            }
        },
        updateUserInfo() {
            if(this.passWord){
            this.passWord = this.passWord.replace(/^\s*|\s*$/g, "");
            }
            let that = this;
            if (this.email && this.email.indexOf('@')==-1 || !commonstate.emailpattern.test(this.email)) {
                this.$toast({
                    text: this.$t('language.login.validEmail'),
                    type: 'fail',
                    idValue: "bindPass"
                });
                return false;
            };
            if (this.passWord&&(this.passWord.length > 16 || this.passWord.length < 8)) {
                this.$toast({
                    text: this.$t('language.login.passwordCharacters'),
                    type: 'fail',
                    idValue: "bindPass"
                });
                return false;
            }
            let changeData;
            var ud = commonUtils.getUser().id;
            if (this.email) {
                this.bindEmailFlag=true;
                //默认用户名
                this.userName = this.email.substring(0,this.email.lastIndexOf("@"));
                if(this.passWord){
                  changeData = {
                    ud: ud,
                    email: this.email.trim(),
                    password: this.passWord.trim(),
                    username: this.userName.trim().replace(/\s+/ig, " "),
                }
                localStorage.removeItem(ud+'interimPsd');
                }else{
                    changeData = {
                    ud: ud,
                    email: this.email.trim(),
                    username: this.userName.trim().replace(/\s+/ig, " "),
                }
                }
            } else {
                this.bindEmailFlag=false;
                if(this.passWord){
                changeData = {
                    ud: ud,
                    password: this.passWord.trim(),
                    username: this.userName.trim(),
                }
                 localStorage.removeItem(ud+'interimPsd')
                }else{
                     changeData = {
                    ud: ud,
                    username: this.userName.trim(),
                }
                }
            }
            if(this.email|| this.passWord){//账号或密码有一个参数存在才调用修改账号接口
            that.Utils.doUserHaveLoginRequest("update", changeData).then(res => {
                if (res.status == 200) {
                    if(that.bindEmailFlag){
                      googleAnalyticsUtil.bindEmail(that, res.user);
                      that.bindEmailRequest();
                    }
                    commonUtils.refreshUserInfo(that,function(res){});
                    if(!that.paySource){
                        if( that.$parent.$refs.rightContBan){
                            that.$parent.$refs.rightContBan.resetEmail = false;
                        }
                    }
                    that.$toast({
                        text: this.$t('language.login.updatedSuccessfully'),
                        type: 'success',
                        idValue: "rightContBan"
                    });
                    that.closePage();
                    if (changeData.email) {
                        that.$store.state.resetEmail = false;
                        let t = setTimeout(() => {
                            that.$toast({
                                text: this.$t('language.login.thankBindEmail'),
                                type: 'success',
                                idValue: "rightContBan"
                            });
                            clearTimeout(t);
                        }, 2000);
                    }
                    //如果购买来源不为空则继续进行用户的购买操作
                    that.openBuyPage();
                } else {
                    this.$toast({
                        text: this.$t('language.exception.' + res.reason),
                        type: 'fail',
                        idValue: "rightContBan"
                    });
                 
                }

            });
            }
        },
        openBuyPage(){
         if(this.paySource){
             //普通购买
             if(this.paySource=='paySys'){
                this.$parent.upgradePlan(this.item);
             }
             //第一个营销弹窗购买
             if(this.paySource=='openSaleOne'){
                 this.$parent.$parent.$refs.limitedSaledDialog.openPage(this.item.index,this.item);
             }
             //第二个营销弹窗购买
             if(this.paySource=='openSaleTwo'){
                 this.$parent.$parent.$refs.limitedSaledDialog.buyUnlimited();
             }
             //如果是万圣节活动
             if(this.paySource=='halloween'){
                 this.$parent.$parent.$refs.halloweenSaleDialog.upgrade(this.item);
             }
             //更新右上角流量进度条
              this.$parent.$parent.$refs.rightContBan.createPage();
             
         }
        },
        bindEmailRequest(){//发送绑定邮箱请求,并刷新用户流量数据
             let that=this;
             let lang = commonUtils.caseIndexLanguage(this.$i18n.locale);
             let ud = commonUtils.getUser().id;
               let getData = {
                ud: ud,
                workUrl:commonstate.nowNewUrl+ ((lang == 'en'||lang == 'pt')?'':'/'+lang) +'/account.html?code='
            }
            this.Utils.doEmailRequest("send_activate_code", getData).then(res => {
                commonUtils.refreshUserInfo(that,function(res){});
            });
        },
        checkShowPassword(){
            this.showPassword = !this.showPassword;
            if(this.showPassword){
                this.$refs.passWord.type = "text";
            }else{
                this.$refs.passWord.type = "password";
            }
        },
    }
}
</script>

<style>
#bindPass {
    width: 500px;
    /*no*/
    height: 260px;
    /*no*/
    border-radius: 10px;/*no*/
}

.personInfo-content {
    width: 100%;
    height: 220px;
    /*no*/
    box-sizing: border-box;
    padding: 20px;
    /*no*/
    color: #6f7886;
    font-size: 14px;
    /*no*/
}

.personInfo-line {
    width: 100%;
    height: 40px;
    /*no*/
    float: left;
    line-height: 28px;
    /*no*/
}

.personInfo-line-text {
    width: 140px;
    /*no*/
    float: left;
    text-align: right;
}


.personInfo-line-input {
    float: left;
    margin-left: 20px;
    /*no*/
    width: 320px;
    /*no*/
    margin-top: 0;
    height: 30px;
    /*no*/
    color: #6f7886;
}


.before-subscribe{
    float: left;
    margin-bottom:15Px ;
    width: 100%;
    display: flex;
    height: 20Px;
    justify-content: center; /*定义body的里的元素水平居中*/
    line-height: 20Px;
}

.scribe-button{
    float: right;
    position: relative;
    left: -20Px;
    top: 5Px;
    width: 100Px;
}

.icon-notice{
    width: 20Px;
    height: 20Px;
    background-image: url("../../../assets/images/paySystem/icon_prompt.png");
    margin-right: 10Px;
}

.personInfo-column span {
    line-height: 50Px;
    color: #000000;
    font-weight: 400;
}

.personInfo-column input {
    margin: 8Px 0;
    border-radius: 6Px;
    font-size: 14px;/*no*/
    font-family: Helvetica;
    line-height: 24px;/*no*/
    color: #6F7886;
}

.personInfo-column {
    display: inline-flex;
    flex-direction: column;
}

.personInfo-column-msg {
    flex: 1;
    padding-left: 20Px;
}

.personInfo-column-msg p{
    margin: 17Px 0;
    padding-left: 10Px;
    word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/personal_center_popups/bind_email_popup.vue